<h2 mat-dialog-title class="mat-dialog-title-offset">Learning band and progress reference table</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
    <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
        <div class="close-modal modal-close-icon">
        </div>
    </button>
</div>
        
<mat-dialog-content class="mat-typography modal-master-container tw:mx-2">
    <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

        <div class="tw:flex tw:flex-wrap tw:px-0 tw:mx-0">
            <div class="tw:flex-1 tw:px-0 tw:mx-0">

            </div>
        </div>

        <div class="tw:flex tw:flex-wrap tw:px-0 tw:pb-6 tw:mx-0 tw:mb-2">

            <div class="tw:w-full tw:p-0 tw:m-0">

                <table>
                    <tbody>
                        <tr>
                            <td rowspan="2">
                                <p><strong>Key Stage</strong></p>
                            </td>
                            <td colspan="5" class="tw:text-center">
                                <p><strong>Learning Bands</strong></p>
                            </td>
                            <td rowspan="2">
                                <p><strong>School Year</strong></p>
                            </td>
                            <td rowspan="2">
                                <p><strong>School Age</strong></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><strong>Band&nbsp;1 W</strong></p>
                            </td>
                            <td>
                                <p><strong>Band 2 W+</strong></p>
                            </td>
                            <td>
                                <p><strong>Band 3 M</strong></p>
                            </td>
                            <td>
                                <p><strong>Band 4 M+</strong></p>
                            </td>
                            <td>
                                <p><strong>Band 5 E</strong></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Pre KS1</p>
                            </td>
                            <td>
                                <p>W/P</p>
                            </td>
                            <td>
                                <p>W+/P</p>
                            </td>
                            <td>
                                <p>M/P</p>
                            </td>
                            <td>
                                <p>M+/P</p>
                            </td>
                            <td>
                                <p>E/P</p>
                            </td>
                            <td>
                                <p>N/A</p>
                            </td>
                            <td>
                                <p>Variable</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>KS 1</p>
                            </td>
                            <td>
                                <p>W/KS1</p>
                            </td>
                            <td>
                                <p>W+/KS1</p>
                            </td>
                            <td>
                                <p>M/KS1</p>
                            </td>
                            <td>
                                <p>M+/KS1</p>
                            </td>
                            <td>
                                <p>E/KS1</p>
                            </td>
                            <td>
                                <p>Years 1 &amp; 2</p>
                            </td>
                            <td>
                                <p>5 &ndash; 7 years</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Lower KS 2</p>
                            </td>
                            <td>
                                <p>W/LKS2</p>
                            </td>
                            <td>
                                <p>W+/LKS2</p>
                            </td>
                            <td>
                                <p>M/LKS2</p>
                            </td>
                            <td>
                                <p>M+/LKS2</p>
                            </td>
                            <td>
                                <p>E/LKS2</p>
                            </td>
                            <td>
                                <p>Year 3 &amp; 4</p>
                            </td>
                            <td>
                                <p>7 &ndash; 9 years</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Upper KS 2</p>
                            </td>
                            <td>
                                <p>W/UKS2</p>
                            </td>
                            <td>
                                <p>W+/UKS2</p>
                            </td>
                            <td>
                                <p>M/UKS2</p>
                            </td>
                            <td>
                                <p>M+/UKS2</p>
                            </td>
                            <td>
                                <p>E/UKS2</p>
                            </td>
                            <td>
                                <p>Year 5 &amp; 6</p>
                            </td>
                            <td>
                                <p>9 &ndash; 11 years</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>KS 3</p>
                            </td>
                            <td>
                                <p>W/KS3</p>
                            </td>
                            <td>
                                <p>W+/KS3</p>
                            </td>
                            <td>
                                <p>M/KS3</p>
                            </td>
                            <td>
                                <p>M+/KS3</p>
                            </td>
                            <td>
                                <p>E/KS3</p>
                            </td>
                            <td>
                                <p>Year 7,8 &amp; 9</p>
                            </td>
                            <td>
                                <p>11 &ndash; 14 years</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>KS 4</p>
                            </td>
                            <td>
                                <p>W/KS4</p>
                            </td>
                            <td>
                                <p>W+/KS4</p>
                            </td>
                            <td>
                                <p>M/KS4</p>
                            </td>
                            <td>
                                <p>M+/KS4</p>
                            </td>
                            <td>
                                <p>E/KS4</p>
                            </td>
                            <td>
                                <p>Year 10 &amp; 11</p>
                            </td>
                            <td>
                                <p>14 &ndash; 16</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p class="tw:mt-12">W= Limited Knowledge W+ = Basic Knowledge M = Meets most M+ = Meets all E = Secure / Exceeds</p>
            </div>

        </div>

        
    </div>
</mat-dialog-content>

<mat-dialog-actions class="div-flex-buttons">
    <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:w-full">
        <div class="tw:w-full tw:p-0 tw:m-0">
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-left" [mat-dialog-close]="false" tabindex='-1'>Close</button>
        </div>
    </div>
</mat-dialog-actions>